import React, { useState, useEffect } from 'react';
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {Links} from '../../routes/PathLink';
import {
  useStockPostQuery, 
  useStorePostMutation, 
  useLikePostMutation, 
  useStockPostInfiniteQuery,
  useRepostMutation,
  useReplyMutation,
  useReplyInfiniteQuery
} from '../../data/forum-details';
import { cleanCompanyName, formatPostTime, toast_anim , toast_anim_error} from "../../components/config/Common";
import {APP_URL, APP_NAME} from 'components/config/Common'
import TextArea  from "../../components/ui/text-area";
import Button from 'components/ui/Button.tsx'
import { MdOutlineWatchLater } from "react-icons/md";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {useAuth} from 'contexts/provider/AuthProvider';

import {
   Control,
   FieldErrors,
   useForm,
   useFormState,
   useWatch,
   Controller
 } from 'react-hook-form';


import ModalView from '_utils/ModalView'
import LoginwithEmail from "components/auth/user/LoginwithEmail";
import SocialLogin from "components/auth/SocialLogin";
import { BiLike, BiRepost } from "react-icons/bi";
import { BsFillReplyFill } from "react-icons/bs";

 const SignupSchema = Yup.object().shape({
      content: Yup.string()
            .required('You must need to provide your content.')
            .test(
             "min-words",
             "Your post must contain at least 2 words.",
             (value) => {
               if (!value) return false;
 
               const words = value
                 .trim()
                 .split(/\s+/)   // split by spaces, tabs, newlines
                 .filter(Boolean);
 
               return words.length >= 2;
             }
           ),
  });
  
  const defaultValues = {     
     content:'',
   };
const ForumShowOnCompany = ({product}) => {
    const [access_token,setAccess_token] = useState(localStorage.getItem('access_token'));
    const [isLogin, setIsLogin] = useState(false)

    //console.log('company symbol===', product)
    const [openReply, setOpenReply] = useState(false);
    const [replyText, setReplyText] = useState("");
    const [openReplies, setOpenReplies] = useState(false);
    const [postReplyId, setPostReplyId] = useState();
    const [openPostId, setOpenPostId] = useState(null);
    const [activeReplyPostId, setActiveReplyPostId] = useState(null);

    const { mutate: store_post, isPending } = useStorePostMutation();
    
    const {isUser} = useAuth();
    const navigate = useNavigate();
    
    const [open, setOpen] = useState(false);
    
    const openPopup = () => {
        setOpen(true);
    };

    //console.log('isUser forum===', window.location.href, isUser)

    useEffect(() => {
        if(access_token){
            setIsLogin(true)
        }
    }, [access_token])

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetchingNextPage,
    } = useStockPostInfiniteQuery({
        company_id: product?.id,
        limit: 5,
        enabled: !!product   // 🚀 wait until company is loaded
    });
    const posts = data?.pages?.flatMap(page => page.data) || [];

    const totalPosts = data?.pages[0]?.total;
    //console.log('post====', totalPosts)
    

    const {
      data: replyData,
      fetchNextPage: fetchNextReplies,
      hasNextPage: hasMoreReplies,
      isFetchingNextPage: loadingReplies
    } = useReplyInfiniteQuery({
      postId: openPostId,
      enabled: !!openPostId
    });


    const replies = replyData?.pages.flatMap(p => p.data) || [];

    const { mutate: repost } = useRepostMutation();
    
    const { mutate: toggleLike } = useLikePostMutation(product?.id);
    
    const togglePostLike = (postId) => {
        toggleLike(
            postId,
            {
            onError: (error) => {
            console.log("errors===",error.message);
            let err = error?.response?.data?.message || "Something went wrong";
            toast_anim_error(err);
            
            
            },
            onSuccess: (data) => {
            console.log("Data REsponse ",data);
            //reset({ content: "" });
            if(data?.status == 200){
                toast_anim(data?.message);
            }
            
            },
            }
        )
    }
    
    const { mutate: reply } = useReplyMutation(product?.id);
    
    const sendReply = (postId, text) => {
        if(!isUser){
            navigate(
                Links.LOGIN,
                {
                    state: { company: product?.id },
                    replace: true 
                },
                
            );
            return;
        }

        if (!text.trim()) return;
        
        console.log("replay===",text, product?.id)
        reply({ postId, content: text });
        setReplyText("");
        setOpenReply(false);
    };

    const { register, handleSubmit , control, reset, setValue, setError, formState: { errors },} = useForm({
          defaultValues: defaultValues,
          resolver: yupResolver(SignupSchema),
          shouldFocusError:false,
        });
    
    const store_stock_post = async (values) => {
    
          //console.log('form values===', values.content)
        store_post(
        {
            content: values.content,
            company_id: product?.id,
        },
        {
            onError: (error) => {
            //console.log("errors===",error.message);
            let err = error?.response?.data?.message || "Something went wrong";
            toast_anim_error(err);
            setError("content", {
                type: "server",
                message: err,
            });
            
            },
            onSuccess: (data) => {
            //console.log("Data REsponse ",data);
            reset({ content: "" });
            if(data?.status == 200){
                toast_anim(data?.message);
            }
            
            },
        }
        );

    }

    const handleLikeClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      togglePostLike(postId);
    };

    const handleReplyClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      setActiveReplyPostId(postId);
    };

    const handleRepostClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      repost(postId);
    }
    const handleReportClick = (postId) => {
      if (!isLogin) {
        openPopup();   // login modal
        return;
      }

      //setOpenReportPostId(postId);
    }

    //console.log('company forum===', posts)
    const SkeletonPost = () => (
      <div className="bg-white p-4 rounded shadow animate-pulse">
        <div className="h-4 bg-gray-200 w-1/4 mb-2 rounded"></div>
        <div className="h-3 bg-gray-200 w-full mb-2 rounded"></div>
        <div className="h-3 bg-gray-200 w-3/4 rounded"></div>
      </div>
    );



    return (
        <div className="w-full mx-auto">
            <section className="z-50 ">
                <h2 className="text-2xl my-5">Forum</h2>
                <div className='bg-white shadow rounded my-5 border border-gray-300 p-4'>
                    {!isLogin ? (
                        <div className="text-center">
                          <p className="mb-4">Please <button onClick={openPopup} className="text-accent underline">login</button> to participate in the forum.</p>
                        </div>
                      ) : (
                    <form onSubmit={handleSubmit(store_stock_post)}>  
                      <TextArea                        
                        style={{ width: "100%", fontSize: 16 }}
                        placeholder="What’s your opinion?"
                        required
                        {...register('content')}  
                        error={errors.content?.message}
                      />
                      <Button 
                        className="my-2" 
                        size="small"
                        disabled={isPending}
                      >{isPending ? "Posting..." : "Post"}</Button>
                    </form>
                      )}
                </div>
                {isLoading && (
                    <div className="space-y-4 p-4">
                    {[...Array(5)].map((_, i) => (
                        <SkeletonPost key={i} />
                    ))}
                    </div>
                )}

                {
                !isLoading && posts?.map(rec=>(

                <div className="bg-white shadow rounded my-5 border border-gray-300">
                    <div className='p-4'>
                    <h2 className='text-lg font-semibold'>{cleanCompanyName(product?.name)}</h2>
                    
                    <div className='flex items-center justify-between'>
                        <div className="text-xs font-semibold py-3">{rec?.user?.name}</div>
                        <div className="flex gap-1 items-center text-xs text-gray-500">
                        <MdOutlineWatchLater /> <div>{formatPostTime(rec.created_at)}</div>
                        </div>
                    </div>
                    {rec?.repost_id ? (
                        <div className="bg-gray-100 p-4 rounded text-sm">
                        <div className='pb-3'>🔁 Reposted from <b>{rec?.reposted_post?.user.name}</b></div>
                        <div className="text-sm text-body whitespace-pre-line break-words">{rec?.reposted_post?.content}</div>
                        </div>
                    ) :                        
                    <div className="text-sm text-body whitespace-pre-line break-words">
                        {rec?.content}
                    </div>
                    }

                    {rec?.replies?.map(r=>(
                        <div className="ml-6 mt-2 border-l pl-3">
                        <div className='flex items-center justify-between'>
                            <div className="text-xs font-semibold py-3">{r?.user?.name}</div>
                            <div className="flex gap-1 items-center text-xs text-gray-500">
                            <MdOutlineWatchLater /> <div>{formatPostTime(r?.created_at)}</div>
                            </div>
                        </div>
                        <div className='text-sm text-body whitespace-pre-line break-words'>{r?.content}</div>
                        
                        </div>
                    ))}
                    {openPostId === rec.id && replies.map(r => (
                        <div className="ml-6 mt-2 border-l pl-3">
                        <div className='flex items-center justify-between'>
                            <div className="text-xs font-semibold py-3">{r?.user?.name}</div>
                            <div className="flex gap-1 items-center text-xs text-gray-500">
                            <MdOutlineWatchLater /> <div>{formatPostTime(r?.created_at)}</div>
                            </div>
                        </div>
                        <div className='text-sm text-body whitespace-pre-line break-words'>{r?.content}</div>
                        
                        </div>
                    ))}
                    

                    </div>
                    <div className="bg-gray-300 flex gap-4 text-sm mt-2 p-3">
                    <button
                        onClick={() => handleLikeClick(rec?.id)}
                        className={`flex items-center gap-1 ${
                        rec.user_liked ? "text-blue-600" : "text-gray-500"
                        }`}
                    >
                       <BiLike className='text-lg' /> Like {rec?.likes_count || null }
                    </button>

                    <button className="flex items-center gap-1 text-gray-500" onClick={() => handleReplyClick(rec.id)}><BsFillReplyFill className='text-xl' /> Reply {rec?.replies_count || null}</button>
                    {/* <button className="flex items-center gap-1 text-gray-500" onClick={() => handleRepostClick(rec?.id)}><BiRepost className='text-xl' /> Repost {rec?.reposts_count || null}</button> */}
                    </div>
                    {activeReplyPostId === rec.id && (
                    <div className="mt-2 p-3 border rounded bg-gray-50">
                        <TextArea
                        value={replyText}
                        onChange={e => setReplyText(e.target.value)}
                        placeholder="Write a reply..."
                        rows={3}
                        />
                        {!isUser ?
                            <div>
                                <Link
                                    to={`${Links.LOGIN}`}
                                    className="flex items-center font-medium  no-underline uppercase antialiased transition duration-200 text-body hover:text-secondary-color focus:text-secondary-color dark:text-zinc-400"
                                >
                                   Click Here to login  
                                </Link>
                            </div>
                        :
                        <Button
                        onClick={() => sendReply(rec?.id, replyText)}
                        className="my-2" 
                        
                        size="small"
                        >
                        Reply
                        </Button>
                        }
                        
                    </div>
                    )}
                </div>
                ))}
            </section>
            {totalPosts > 5 && <Link to={`${APP_URL}${Links.COMPANY}/${product.symbol}${Links.FORUM}`} className='text-white bg-accent box-border border border-transparent hover:bg-secondary focus:ring-4 focus:ring-brand-medium shadow-xs font-medium leading-5 rounded-base text-sm px-4 py-2.5 focus:outline-none'>View All</Link>}
            <ModalView open={open} onClose={() => setOpen(false)}>
                <div className="flex flex-col justify-center">
                    <div className="text-center text-base text-body">Don't have an account? <Link to={`${Links.USER_SIGNUP}`} className="text-accent underline transition-colors duration-200 hover:text-accent-hover hover:no-underline focus:text-accent-hover focus:no-underline focus:outline-none ltr:ml-1 rtl:mr-1">Create New</Link></div>
                    
                </div>  
                <LoginwithEmail goTo={window.location.href} />
                <SocialLogin mode='Login' user_type='user' goTo={window.location.href} />
            </ModalView>
        </div>
    )


}

export default ForumShowOnCompany;